import { render, staticRenderFns } from "./PUDetailsTime.vue?vue&type=template&id=2ab18278&scoped=true"
import script from "./PUDetailsTime.vue?vue&type=script&lang=js"
export * from "./PUDetailsTime.vue?vue&type=script&lang=js"
import style0 from "./PUDetailsTime.vue?vue&type=style&index=0&id=2ab18278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab18278",
  null
  
)

export default component.exports